@for (stage of stages; track $index) {
  <div>
    <div [ngClass]="launchStatus[stage.status].class">
      <i [ngClass]="launchStatus[stage.status].icon" aria-hidden="true"></i>
      {{ stage.text | translate }}
      @if (stage.status === "INPROGRESS") {
        <div class="spinner-border small"></div>
      }
    </div>
  </div>
}
